import { render, staticRenderFns } from "./GiropayHeader.vue?vue&type=template&id=58121564&scoped=true&"
import script from "./GiropayHeader.vue?vue&type=script&lang=js&"
export * from "./GiropayHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58121564",
  null
  
)

export default component.exports